import { Injectable } from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';
import { CartService } from 'src/app/services/api/cart.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

	user: any = {};
	userData: any = null;

	constructor(
		public storage: StorageService,
		public router: Router,
    	public cartService: CartService
	) { }

	checkLogin(){
		return new Promise(res => {
			this.storage.get('user').then(resolve => {
				if(resolve){
					this.user = resolve;
					/*this.cartService.makeRequest('/rest/entrelable/V1/customers/me', '', 'GET').then(customer => {
						this.userData = customer;
					});*/
					res(resolve);
				} else {
					res(null);
				}
			});
		});
	}

	/**
	 * set user as log out
	 * remove all the storage data
	 */ 
	signOut(redirectPath:any = '/', redirect:boolean=true){
		this.storage.removeItem('user').then(resolve => {
			this.user = {};
			this.userData = null;
			this.storage.removeItem('cart_id');
			this.cartService.cart = null;
			this.cartService.cartMine = null;
			this.cartService.cartItems = null;
			if(redirect){
				this.router.navigate([redirectPath]);
			}
		});
	}

}
